import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconPhone = ({ id, color, width = 14, style, ...restProps }: IProps) => {
  const viewBoxWidth = 14;
  const viewBoxHeight = 14;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M10.1 8.5zM3.9 1.1c-1.1.1-2.1.8-2.5 1.8-.4 1-.4 1.9.2 2.9 1.6 2.6 3.7 4.7 6.3 6.3.8.5 1.7.6 2.6.3 1.2-.4 2-1.4 2-2.6-.9-.3-1.8-.7-2.6-1l-.4.4-.4.4-.1.1-.1.1c-.2.2-.5.2-.7.1C6.5 8.8 5 7.3 3.8 5.6c-.1-.4-.1-.7.1-.8l.3-.3.7-.7c-.3-.8-.5-1.6-.8-2.3l-.2-.4zm5.6 12.5c-.7 0-1.5-.2-2.2-.6-2.8-1.6-5-3.9-6.7-6.7-.7-1.2-.8-2.6-.3-3.9C1 .9 2.5 0 4.1 0c.4 0 .6.1.8.5l.2.5c.3.8.6 1.7 1 2.5.1.3 0 .6-.2.8-.3.3-.6.6-.8.9 1 1.3 2.1 2.5 3.4 3.4l.2-.2.6-.6c.2-.2.5-.3.8-.2 1 .4 2.1.8 3.1 1.2.2.1.5.2.5.7 0 1.8-1.1 3.4-2.8 4-.5.1-1 .1-1.4.1z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconPhone;
